
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cards/[slug]",
      function () {
        return require("private-next-pages/cards/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cards/[slug]"])
      });
    }
  